export default __webpack_public_path__ + "static/media/Elemental End.f572cd59.ttf";